$( function() {
	var running = false;

	function getImages(append, resetpage) {
		if(running) return;

		running = true;
		$form = $('form[name=admin_getimages]');
		var _url = $form.attr('action');
		var formData = {};
		formData.type = $form.find('select[name=type]').val();
		formData.order = $form.find('select[name=order]').val();
		formData.page = parseInt($form.find('input[name=page]').val()) + 1;

		if(resetpage !== undefined) {
			formData.page = resetpage;
		}

		$gal = $('ul.gallery');

		$.get(_url, formData, function(res) {
			running = false;
			$form.find('input[name=page]').remove();
			$form.append($('<input type="hidden" name="page" value="'+formData.page+'"/>'));
			if(!append) {
				$gal.empty();
			}
			$(res).hide().appendTo($gal).fadeIn();
			$gal.Chocolat({
				imageSelector: '.img-wrapper'
			});
		}, 'html');
	}

	$('form[name=admin_getimages]')
	.find('select[name=type]').on('change', function(res) {
		$(this).closest('form').find('input[name=page]').val(0);
		getImages(false);
	});

	$('form[name=admin_getimages]')
	.find('select[name=order]').on('change', function(res) {
		$(this).closest('form').find('input[name=page]').val(0);
		getImages(false);
	});

	$('body.admin').on('loadimages', function(evt, append) {
		console.log('loading');
		evt.preventDefault();
		if(append === false) {
			getImages(false);
		}
		else {
			getImages(true);
		}
	});

	$('body.admin').find('.btn-load-more').on('click', function(e) {
		e.preventDefault();
		getImages(true);
	});

	$('body.admin').trigger('loadimages');
});